import React from 'react';
import { Phone, Calendar, Linkedin } from 'lucide-react';

const Contact = () => {
  const contactOptions = [
    {
      icon: Phone,
      title: 'Call Us Today',
      description: 'Ready to discuss your financial goals? Schedule your free consultation and take the first step toward financial empowerment.',
      buttonText: 'Call Now',
      action: () => window.location.href = 'tel:+13362528710'
    },
    {
      icon: Calendar,
      title: 'Book Online',
      description: 'Use our convenient online scheduling system to find a time that works for your busy schedule.',
      buttonText: 'Schedule Appointment',
      action: () => window.open('https://go.sbrooksassociatesllc.com/bookwithshannon', '_blank')
    },
    {
      icon: Linkedin,
      title: 'Connect With Us',
      description: 'Follow us on LinkedIn for daily financial tips and community updates.',
      buttonText: 'Follow Us',
      action: () => window.open('https://www.linkedin.com/in/shannon-brooks336/', '_blank')
    }
  ];

  return (
    <section className="bg-gradient-to-br from-[#D0E8F2] to-[#C4E5F4] py-20 px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-serif text-[#0A2540] font-bold text-center mb-16">
          Let's Start a Conversation
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {contactOptions.map((option, index) => {
            const Icon = option.icon;
            return (
              <div key={index} className="bg-white rounded-xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 space-y-6">
                <div className="flex justify-start">
                  <div className="bg-[#C4E5F4] p-4 rounded-full">
                    <Icon className="h-8 w-8 text-[#0B8FD8]" />
                  </div>
                </div>
                <h3 className="text-xl md:text-2xl font-serif text-[#0A2540] font-bold">
                  {option.title}
                </h3>
                <p className="text-base text-[#2C3E50] leading-relaxed">
                  {option.description}
                </p>
                <button
                  onClick={option.action}
                  className="text-[#0B8FD8] hover:text-[#0973B0] font-semibold text-base transition-colors duration-300 underline"
                >
                  {option.buttonText}
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Contact;
